import { InsecureContextError, useAuth } from '@platform/auth-client';
import { useTranslation } from '@platform/i18n';
import { useCallback, useState } from 'react';

export type SignInAttempt = 'idle' | 'redirecting' | 'failed' | 'insecure';

export type SignIn = {
  attempt: SignInAttempt;
  start: () => void;
};

export const useSignIn = (returnTo: () => string, initialAttempt: SignInAttempt = 'idle'): SignIn => {
  const { i18n } = useTranslation();
  const auth = useAuth();
  const [attempt, setAttempt] = useState<SignInAttempt>(initialAttempt);

  const start = useCallback((): void => {
    setAttempt('redirecting');
    auth.login({ returnTo: returnTo(), locale: i18n.language }).catch((error: unknown) => {
      setAttempt(error instanceof InsecureContextError ? 'insecure' : 'failed');
    });
  }, [auth, returnTo, i18n.language]);

  return { attempt, start };
};
